function scrollbar() {
  const getWidth = () => {
    const inner = document.createElement('p');
    inner.style.width = '100%';
    inner.style.height = '200px';

    const outer = document.createElement('div');
    outer.style.position = 'absolute';
    outer.style.top = '0px';
    outer.style.left = '0px';
    outer.style.visibility = 'hidden';
    outer.style.width = '200px';
    outer.style.height = '150px';
    outer.style.overflow = 'hidden';
    outer.appendChild(inner);

    document.body.appendChild(outer);
    const w1 = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    let w2 = inner.offsetWidth;
    if (w1 === w2) {
      w2 = outer.clientWidth;
    }
    document.body.removeChild(outer);

    return (w1 - w2);
  };

  function setCss() {
    const rootName = 'sidebar-css';
    let sidebarCss;
    const width = getWidth();

    sidebarCss = document.querySelector(`.${rootName}`);

    if (!sidebarCss) {
      sidebarCss = document.createElement('style');
      sidebarCss.classList.add(rootName);
      document.querySelector('head').appendChild(sidebarCss);
    }

    sidebarCss.textContent = `
      .u-no-y-scroll {
        overflow-y: hidden;
        padding-right: ${width}px;
      }
      .u-width-calc-100-minus-scrollwidth {
        width: calc(100% - ${width}px);
      }
      .u-right-scrollwidth {
        right: ${width}px;
      }
    `;
  }

  setCss();

  window.addEventListener('resize', () => {
    setCss();
  });

  //
  // Public API
  //

  return {
    get width() {
      return getWidth();
    },
  };
}

export default scrollbar();



// WEBPACK FOOTER //
// ./src/scripts/utils/scrollbar.js